<template>

<div id="app">

    <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-card color="grey lighten-4" flat>

        <v-layout row wrap>

            <v-flex xs12 sm12>

                <v-toolbar size="120px" dark color="info">

                    <v-toolbar-title class="baslikfont">{{ $t('Statement-of-Reconciliation') }}</v-toolbar-title>

                    <v-spacer></v-spacer>

                    <v-text-field flat="" solo-inverted="" hide-details v-model="search3"  :label="this.$t('Search')" append-icon="search">

                    </v-text-field>

                    <v-btn color="pink lighten-1" dark @click="openMailDialog" small>

  <v-icon left>email</v-icon> Mail Gönder

</v-btn>

                    <v-menu offset-y>

                        <v-btn slot="activator" dark icon>

                            <v-icon>more_vert</v-icon>

                        </v-btn>

                        <v-list>

                            <v-list-tile @click="getListHtml()">

                                <v-list-tile-title>Html {{ $t('Download') }}</v-list-tile-title>

                            </v-list-tile>

                            <v-list-tile @click="getListExcel()">

                                <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>

                            </v-list-tile>

                            <v-list-tile @click="emutabakatIndir()">

                                <v-list-tile-title>E-Mutabakat İndir</v-list-tile-title>

                            </v-list-tile>

                        </v-list>

                    </v-menu>

                </v-toolbar>

            </v-flex>

<!-- MAIL GÖNDER DIALOG -->

<v-dialog v-model="mailDialog" persistent max-width="640px" scrollable>

  <v-card>

    <v-toolbar dense flat color="info" dark>

      <v-toolbar-title>Mail Gönder</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon @click="closeMailDialog"><v-icon>close</v-icon></v-btn>

    </v-toolbar>

    <v-card-text>

      <v-form ref="mailForm" v-model="mailValid" lazy-validation>

        <v-layout wrap>

          <v-flex xs12>

            <v-text-field

              v-model="mailPayload.To"

              label="Kime (e-posta)"

              :rules="[rules.required, rules.email]"

              clearable

            ></v-text-field>

          </v-flex>

          <v-flex xs12 sm6>

            <v-text-field

              v-model="mailPayload.AgencyName"

              label="Agency Name"

              :rules="[rules.required]"

              clearable

            ></v-text-field>

          </v-flex>

          <v-flex xs12 sm6>

            <v-text-field

              v-model="mailPayload.DocType"

              label="Doc Type (sabit)"

              :rules="[rules.required]"

              :disabled="true"

            ></v-text-field>

          </v-flex>

          <v-flex xs12 sm6>

            <v-text-field

              v-model="mailPayload.AgentFullName"

              label="Agent Full Name"

              :rules="[rules.required]"

              clearable

            ></v-text-field>

          </v-flex>

          <v-flex xs12>

            <v-textarea

              v-model="mailPayload.CustomBody"

              label="Mesaj"

              :rules="[rules.required]"

              auto-grow

              rows="3"

            ></v-textarea>

          </v-flex>

        </v-layout>

      </v-form>

    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>

      <v-spacer></v-spacer>

      <v-btn flat @click="closeMailDialog">Vazgeç</v-btn>

      <v-btn

        color="info"

        :loading="mailLoading"

        :disabled="!mailValid || mailLoading"

        @click="sendMail"

      >

        <v-icon left>send</v-icon>Gönder

      </v-btn>

    </v-card-actions>

  </v-card>

</v-dialog>



            <v-container fluid>

                <v-card color="grey lighten-5" flat>

                    <v-form ref="formtarih" v-model="valid" lazy-validation>

                        <v-layout row wrap>

                            <v-flex xs12 pa-1 sm6 md2>

                                <tarihcomp :etiket="$t('Date')" :detaygizle="false" :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'" v-bind:value="Mutabakat.Tarih" v-model="Mutabakat.Tarih"></tarihcomp>

                            </v-flex>

                            <v-flex pt-1>

                                <v-layout align-center row fill-heigth>

                                    <div v-if="load1">

                                        <v-btn color="info" @click="getList()" fab small="" dark>

                                            <v-icon>search</v-icon>

                                        </v-btn>

                                    </div>

                                    <div v-if="!load1">

                                        <v-layout pt-2 align-center row fill-heigth>

                                            <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>

                                        </v-layout>

                                    </div>

                                    <v-badge color="white" :overlap="true">

                                        <template v-slot:badge>

                                            <v-icon v-if="filtrevarmi" large color="green">

                                                check_circle_outline </v-icon>

                                        </template>

                                        <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab" @click="filtrele()" color="info" fab dark>

                                            <v-icon>filter_list</v-icon>

                                        </v-btn>

                                        <v-tooltip bottom="" :activator="el" v-model="tooltip">

                                            <span>{{$t('Add-Search-Filter')}}</span>

                                        </v-tooltip>

                                    </v-badge>

                                </v-layout>

                            </v-flex>

                            <v-flex xs12 sm12 md12>

                                <v-card flat>

                                    <!-- Ortak modern rapor tablosu.
                                     Mevcut mutabakat mektubu, E-Mutabakat, backend HTML/Excel ve mail işlemleri korunmuştur. -->
                                <div class="mutabakat-report-table">
                                    <ReportTable
                                        :headers="headers"
                                        :items="mutabakatReportItems"
                                        storage-key="mutabakatmektubu_columns"
                                        :loading="!load1"
                                        :has-searched="items && items.length > 0"
                                        :show-search="true"
                                        :search-label="$t('Search')"
                                        :show-frontend-export="true"
                                        :export-title="$t('Statement-of-Reconciliation')"
                                        :export-meta-items="mutabakatExportMetaItems"
                                        :export-summary-cards="mutabakatExportSummaryCards"
                                        :rows-per-page-items="[50, 100, 250, 500, 1000]"
                                    >
                                        <template slot="cell" slot-scope="{ item, column, value }">
                                            <div v-if="column.value === '__action'" class="mutabakat-action-cell">
                                                <v-btn icon class="mx-0" @click.stop="mektupGetir(item)">
                                                    <v-icon color="green">email</v-icon>
                                                </v-btn>
                                            </div>
                                            <span v-else>{{ value }}</span>
                                        </template>
                                    </ReportTable>
                                </div>

                                </v-card>

                                <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">

                                    {{ text1 }}

                                    <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>

                                </v-snackbar>

                            </v-flex>

                        </v-layout>

                    </v-form>

                </v-card>

            </v-container>

            <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="800px">

                <v-card color="grey lighten-5">

                    <v-card-title>{{ $t('Filter-selection') }}</v-card-title>

                    <v-divider></v-divider>

                    <v-card-text>

                        <v-layout row="" wrap="">

                            <v-flex xs12 sm6 md6>

                                <cariaracomp v-bind:etiket="$t('Select-Starting-Current')" v-bind:value="Mutabakat.BaslangicCari" :loading="loading1" v-model="Mutabakat.BaslangicCari"></cariaracomp>

                            </v-flex>

                            <v-flex xs12 sm6 md6>

                                <cariaracomp v-bind:etiket="$t('Select-Ending-Current')" v-bind:value="Mutabakat.BitisCari" :loading="loading2" v-model="Mutabakat.BitisCari"></cariaracomp>

                            </v-flex>

                            <v-flex xs12 sm6 md6>

                                <v-autocomplete hide-details="" clearable :items="hesapgurubu" :label="$t('Account-Group-Requested')" multiple item-text="Title" v-model="Mutabakat.Gruplar" item-value="Kod">

                                    <template slot="selection" slot-scope="{ item, index }">

                                        <div v-if="index === 0">

                                            <span>{{ item.Title }}</span>

                                        </div>

                                        <span v-if="index === 1" class="grey--text caption">&nbsp;(+{{

                                                                Mutabakat.Gruplar.length -

                                                                1

                                                                }} {{ $t('Other') }})</span>

                                    </template>

                                </v-autocomplete>

                            </v-flex>

                            <v-flex xs12 sm6 md6>

                                <v-autocomplete hide-details="" clearable :items="hesapgurubu" :label="$t('Account-Group-Not-Requested')" multiple item-text="Title" v-model="Mutabakat.NoGruplar" item-value="Kod">

                                    <template slot="selection" slot-scope="{ item, index }">

                                        <div v-if="index === 0">

                                            <span>{{ item.Title }}</span>

                                        </div>

                                        <span v-if="index === 1" class="grey--text caption">&nbsp;(+{{

                                                                Mutabakat.NoGruplar.length -

                                                                1

                                                                }} {{ $t('Other') }})</span>

                                    </template>

                                </v-autocomplete>

                            </v-flex>

                            <v-flex xs12 sm12 pt-4 md12>

                                <v-layout row wrap class=" project overdue">

                                    <v-toolbar flat="" size="120px" dark color="grey lighten-5">

                                        <v-toolbar-title>

                                            <span class="headline black--text font-weight-">

                                                {{ $t('Options-v2') }}

                                            </span>

                                        </v-toolbar-title>

                                        <v-spacer></v-spacer>

                                    </v-toolbar>

                                </v-layout>

                            </v-flex>

                            <v-flex xs12 sm6 md6>

                                <v-layout row wrap>

                                    <v-flex xs12 sm12 md12>

                                        <v-checkbox v-model="Mutabakat.SifirBakiye" hide-details :label="$t('Dont-Show-Zero-Balances')"></v-checkbox>

                                    </v-flex>

                                    <v-flex xs12 sm12 md12>

                                        <v-checkbox hide-details v-model="tumsirketler" :label="$t('All-Companies')"></v-checkbox>

                                    </v-flex>

                                </v-layout>

                            </v-flex>

                        </v-layout>

                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>

                        <v-spacer></v-spacer>

                        <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{$t("cancel_button")}}</v-btn>

                        <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>

                    </v-card-actions>

                </v-card>

            </v-dialog>

        </v-layout>

    </v-card>

</div>

</template>

<script>

import auth from '../../../api/auth'

import tarihcomp from '../customcomp/tarihim'

import helpers from "@/components/app/customcomp/helpers.js"

import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"

import cariaracomp from '@/components/app/customcomp/cariaracomp'
import ReportTable from "@/components/app/customcomp/ReportTable.vue"

export default {

    data() {

        return {

            mailDialog: false,

mailValid: false,

mailLoading: false,

mailPayload: {

  To: "",

  AgencyName: "",

  DocType: "Tarihe Göre Ekstre - Statement of Account by Date",

  AgentFullName: "",

  CustomBody: ""

},

rules: {

  required: v => !!v || 'Zorunlu alan',

  email: v => !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'Geçerli bir e-posta girin'

},

            sayfayetki: {

                Screen: false,

                Update: false,

                Save: false,

                Delete: false,

                Status: false,

                Message: null,

                islem: 0,

            },

            hesapgurubu: [],

            filtrevarmi: false,

            search: '',
            headers: [{
                    text: this.$t('Current-Account-Code'),
                    value: '_CariKod',
                    align: 'left',
                    visible: true,
                    sortable: true,
                    type: 'text',
                    width: '180px'
                },
                {
                    text: this.$t('Title_label'),
                    value: '_CariUnvan',
                    align: 'left',
                    visible: true,
                    sortable: true,
                    type: 'text',
                    width: '320px'
                },
                {
                    text: this.$t('Amount'),
                    value: 'Tutar',
                    align: 'right',
                    visible: true,
                    sortable: true,
                    type: 'money',
                    width: '180px'
                },
                {
                    text: 'B/A',
                    value: 'BA',
                    align: 'center',
                    visible: true,
                    sortable: true,
                    type: 'text',
                    width: '100px'
                },
                {
                    text: '',
                    value: '__action',
                    align: 'center',
                    visible: true,
                    sortable: false,
                    type: 'text',
                    exportable: false,
                    width: '70px'
                }
            ],
            valid: true,

            Mutabakat: {

                SirketKodu: null,

                Tarih: getDateNow(),

                BaslangicCari: null,

                BitisCari: null,

                OzetMutabakat: null,

                SifirBakiye: false,

                Gruplar: [],

                NoGruplar: []

            },

            tumsirketler: '',

            grandDebt: 0,

            dueDebt: 0,

            date: null,

            menu: false,

            modal: false,

            dateFormatted: '',

            loading1: false,

            loading2: false,

            loading3: false,

            statecari: [],

            statecari2: [],

            items: [],

            search1: '',

            search3: '',

            load: false,

            load1: true,

            butondurum: true,

            dialogfiltre: false,

            hesapkodu: [],

            Referans: [],

            masrafmerkezi: [],

            anahesap: [],

            renk1: 'info',

            a: '',

            b: '',

            c: '',

            d: '',

            progress: false,

            snackbar: false,

            y: 'top',

            x: 'right',

            mode: '',

            timeout: 6000,

            text1: '',

            tooltip: false,

            el: null,

            dictionary: {

                custom: {

                    tarihsec: {

                        required: () => this.$t('Please-select-a-date')

                    },

                    tarihsec1: {

                        required: () => this.$t('Please-select-a-date')

                    },

                }

            },

        }

    },

    beforeRouteEnter(to, from, next) {

        next(vm => {

            vm.prevRoute = from.path

        })

    },

    beforeMount: beforeMount,

    components: {

        tarihcomp,

        yetkidialog,

        cariaracomp,
      ReportTable

    },

    mounted() {

        this.el = this.$refs.fab.$el

        this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

        if (this.sayfayetki.Status == true) {

        } else {

            this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

                if (sonuc == true) {

                    if (this.prevRoute != null) {

                        let url = '#' + this.prevRoute

                        window.open(url, '_self')

                    } else {

                        let url = '#/'

                        window.open(url, '_self')

                    }

                }

            });

        }

    },
    computed: {
        mutabakatReportItems() {
            var list = Array.isArray(this.items) ? this.items : []
            var searchText = (this.search3 || '').toString().trim().toLocaleLowerCase()

            var mapped = list.map(function (item) {
                var row = Object.assign({}, item)
                row._CariKod = item && item.Cari ? item.Cari.Kod : ''
                row._CariUnvan = item && item.Cari ? item.Cari.Unvan : ''
                return row
            })

            if (!searchText) {
                return mapped
            }

            return mapped.filter(function (item) {
                return [
                    item._CariKod,
                    item._CariUnvan,
                    item.Tutar,
                    item.BA
                ].some(function (value) {
                    if (value === null || value === undefined) {
                        return false
                    }

                    return value.toString().toLocaleLowerCase().indexOf(searchText) !== -1
                })
            })
        },

        mutabakatExportMetaItems() {
            return [
                {
                    label: this.$t('Date'),
                    value: this.Mutabakat ? this.Mutabakat.Tarih : '',
                    type: 'date'
                },
                {
                    label: this.$t('Select-Starting-Current'),
                    value: this.Mutabakat ? this.Mutabakat.BaslangicCari : ''
                },
                {
                    label: this.$t('Select-Ending-Current'),
                    value: this.Mutabakat ? this.Mutabakat.BitisCari : ''
                },
                {
                    label: this.$t('Dont-Show-Zero-Balances'),
                    value: this.Mutabakat && this.Mutabakat.SifirBakiye ? 'Evet' : 'Hayır'
                },
                {
                    label: this.$t('All-Companies'),
                    value: this.tumsirketler === true ? 'Evet' : 'Hayır'
                }
            ]
        },

        mutabakatExportSummaryCards() {
            return []
        }
    },


    watch: {

    },

    filters: {

        dateformat: function (t) {

            return helpers.dateformat(t);

        },

        moneyformat: function (m) {

            return helpers.moneyformat(m);

        },

        bakiyekontrol: function (m) {

            return helpers.bakiyekontrol(m);

        }

    },

    methods: {

  openMailDialog() {

    if (!this.mailPayload) this.mailPayload = {};

    this.mailPayload.DocType = "Mutabakat Mektubu - Statement of Reconciliation";

    if (this.$refs && this.$refs.mailForm && this.$refs.mailForm.resetValidation) {

      this.$refs.mailForm.resetValidation();

    }

    this.mailDialog = true;

  },

  closeMailDialog() {

    this.mailDialog = false;

  },

  sendMail() {

    if (!(this.$refs && this.$refs.mailForm && this.$refs.mailForm.validate && this.$refs.mailForm.validate())) return;

    if (!(this.$refs && this.$refs.formtarih && this.$refs.formtarih.validate && this.$refs.formtarih.validate())) return;

    var credentialsRaw = window.localStorage.getItem('credentials');

    var credentials = credentialsRaw ? JSON.parse(credentialsRaw) : {};

    var companyCode = this.tumsirketler === true ? '0' : (credentials && credentials.SirketKodu ? credentials.SirketKodu : null);

    var M = this.Mutabakat || {};

    var inputObj = {

      SirketKodu: companyCode,

      Tarih: M.Tarih || null,

      BaslangicCari: M.BaslangicCari || null,

      BitisCari: M.BitisCari || null,

      OzetMutabakat: M.OzetMutabakat || null,

      SifirBakiye: !!M.SifirBakiye,

      Gruplar: Array.isArray(M.Gruplar) ? M.Gruplar : [],

      NoGruplar: Array.isArray(M.NoGruplar) ? M.NoGruplar : []

    };

    var mp = this.mailPayload || {};

    var fallbackDocType = "Mutabakat Mektubu - Statement of Reconciliation";

    var mailObj = {

      To: mp.To ? mp.To : "",

      AgencyName: mp.AgencyName ? mp.AgencyName : "",

      DocType: mp.DocType ? mp.DocType : fallbackDocType,

      AgentFullName: mp.AgentFullName ? mp.AgentFullName : "",

      CustomBody: mp.CustomBody ? mp.CustomBody : ""

    };

    var payload = { Input: inputObj, Mail: mailObj };

    this.mailLoading = true;

    var endpoint = auth.API_URL + 'api/Report/MailGonderMutabakatExcel';

    this.$http.post(endpoint, payload, { headers: { 'Authorization': 'Bearer ' + auth.getAuthHeader() } })

      .then(() => {

        this.mailLoading = false;

        this.mailDialog = false;

        this.text1 = this.$t ? this.$t('Email-sent') : 'Mail gönderildi.';

        this.snackbar = true;

      }, (err) => {

        this.mailLoading = false;

        var body = (err && (err.body || err.data)) ? (err.body || err.data) : {};

        var msg = (body && (body.Message || body.message)) || err.statusText || (this.$t ? this.$t('Email-send-failed') : 'Mail gönderilemedi.');

        this.text1 = msg;

        this.snackbar = true;

      });

  },





        getList: getList,

        getListHtml: getListHtml,

        getListExcel: getListExcel,

        emutabakatIndir: emutabakatIndir,

        filtrele: filtrele,

        filtrekayit: filtrekayit,

        filtreiptal: filtreiptal,

        mektupGetir: mektupGetir

    }

}

function onChangecheck(elem1, elem2) {

    if (this.a === true && elem2 == 'a') {

        this.b = karsidegeral(this.a)

    }

    if (this.b === true && elem2 == 'b') {

        this.a = karsidegeral(this.b)

    }

}

function filtrele() {

    this.dialogfiltre = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params3 = {

        CompanyCode: credentials.SirketKodu

    }

    this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params3, {

        headers: {

            'Authorization': 'Bearer ' + auth.getAuthHeader()

        }

    }).then((response) => {

        this.hesapgurubu = response.body

    }, (response) => {

        if (response.status === 0) {

            this.text1 = 'Service Unavailable'

            this.snackbar = true

        } else {

            this.text1 = 'Service Unavailable'

            this.snackbar = true

        }

    })

}

function filtrekayit() {

    this.dialogfiltre = false

    this.getList();

    this.filtrevarmi = true

}

function filtreiptal() {

    this.dialogfiltre = false

    this.filtrevarmi = false

    this.tumsirketler = false

    this.Mutabakat.OzetMutabakat = null

    this.Mutabakat.SifirBakiye = false

    this.Mutabakat.Gruplar = []

    this.Mutabakat.NoGruplar = []

    this.Mutabakat.BaslangicCari = null

    this.Mutabakat.BitisCari = null

    this.getList();

}

function mektupGetir(v) {

    var yedekmektupInput = {

        SirketKodu: null,

        Tarih: getDateNow(),

        BaslangicCari: null,

        BitisCari: null,

        OzetMutabakat: null,

        SifirBakiye: false

    }

    yedekmektupInput.Tarih = this.Mutabakat.Tarih

    yedekmektupInput.OzetMutabakat = this.Mutabakat.OzetMutabakat

    yedekmektupInput.SifirBakiye = this.Mutabakat.SifirBakiye

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var lang = localStorage.getItem('lang')

    yedekmektupInput.BaslangicCari = v.Cari.Kod;

    yedekmektupInput.BitisCari = v.Cari.Kod;

    if (this.tumsirketler === true) {

        yedekmektupInput.SirketKodu = '0'

    } else {

        yedekmektupInput.SirketKodu = credentials.SirketKodu

    }

    var params = yedekmektupInput

    this.$http.post(auth.API_URL + 'api/Report/CompromiseReportHtml', params, {

        headers: {

            'Authorization': 'Bearer ' + auth.getAuthHeader()

        }

    }).then((response) => {

        var blob = new Blob([response.data], {

            type: 'application/html'

        });

        var link = document.createElement('a');

        link.href = window.URL.createObjectURL(blob);

        link.download = "MutabakatMektubu.html";

        link.click();

        this.progress = false

        this.load1 = true

    }, (response) => {

        if (response.status === 0) {

            this.text1 = 'Service Unavailable'

            this.snackbar = true

            this.progress = false

            this.load1 = true

        } else {

            this.text1 = 'Service Unavailable'

            this.snackbar = true

            this.progress = false

            this.load1 = true

        }

    })

}

function getList() {

    if (this.$refs.formtarih.validate()) {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        this.load1 = false

        if (this.tumsirketler === true) {

            this.Mutabakat.SirketKodu = '0'

        } else {

            this.Mutabakat.SirketKodu = credentials.SirketKodu

        }

        var params = this.Mutabakat;

        this.$http.post(auth.API_URL + 'api/Report/CompromiseReport', params, {

            headers: {

                'Authorization': 'Bearer ' + auth.getAuthHeader()

            }

        }).then((response) => {

            this.items = response.body

            this.progress = false

            this.load1 = true

        }, (response) => {

            if (response.status === 0) {

                this.text1 = 'Service Unavailable'

                this.snackbar = true

                this.progress = false

                this.load1 = true

            } else {

                this.text1 = 'Service Unavailable'

                this.snackbar = true

                this.progress = false

                this.load1 = true

            }

        })

    }

}

function getListHtml() {

    if (this.$refs.formtarih.validate()) {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        this.load1 = false

        if (this.tumsirketler === true) {

            this.Mutabakat.SirketKodu = '0'

        } else {

            this.Mutabakat.SirketKodu = credentials.SirketKodu

        }

        var params = this.Mutabakat;

        this.$http

            .post(auth.API_URL + "api/Report/CompromiseListHtml", params, {

                headers: {

                    Authorization: "Bearer " + auth.getAuthHeader()

                }

            }).then((response) => {

                this.progress = false

                this.load1 = true

                var blob = new Blob([response.data], {

                    type: 'application/html'

                });

                var link = document.createElement('a');

                link.href = window.URL.createObjectURL(blob);

                link.download = "MutabakatRaporu.html";

                link.click();

            }, (response) => {

                if (response.status === 0) {

                    this.text1 = 'Service Unavailable'

                    this.snackbar = true

                    this.load1 = true

                    this.progress = false

                } else {

                    this.text1 = 'Service Unavailable'

                    this.snackbar = true

                    this.load1 = true

                    this.progress = false

                }

            })

    }

}

function getListExcel() {

    if (this.$refs.formtarih.validate()) {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        this.load1 = false

        if (this.tumsirketler === true) {

            this.Mutabakat.SirketKodu = '0'

        } else {

            this.Mutabakat.SirketKodu = credentials.SirketKodu

        }

        var params = this.Mutabakat;

        this.$http

            .post(auth.API_URL + "api/Report/CompromiseListExcel", params, {

                headers: {

                    Authorization: "Bearer " + auth.getAuthHeader()

                },

                responseType: "arraybuffer"

            }).then((response) => {

                this.progress = false

                this.load1 = true

                var blob = new Blob([response.data], {

                    type: 'application/xlsx'

                });

                var link = document.createElement('a');

                link.href = window.URL.createObjectURL(blob);

                link.download = "MutabakatRaporu.xlsx";

                link.click();

            }, (response) => {

                if (response.status === 0) {

                    this.text1 = 'Service Unavailable'

                    this.snackbar = true

                    this.load1 = true

                    this.progress = false

                } else {

                    this.text1 = 'Service Unavailable'

                    this.snackbar = true

                    this.load1 = true

                    this.progress = false

                }

            })

    }

}

function emutabakatIndir() {

    if (this.$refs.formtarih.validate()) {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        this.load1 = false

        if (this.tumsirketler === true) {

            this.Mutabakat.SirketKodu = '0'

        } else {

            this.Mutabakat.SirketKodu = credentials.SirketKodu

        }

        var params = this.Mutabakat;

        this.$http

            .post(auth.API_URL + "api/Report/ECompromiseListExcel", params, {

                headers: {

                    Authorization: "Bearer " + auth.getAuthHeader()

                },

                responseType: "arraybuffer"

            }).then((response) => {

                this.progress = false

                this.load1 = true

                var blob = new Blob([response.data], {

                    type: 'application/xlsx'

                });

                var link = document.createElement('a');

                link.href = window.URL.createObjectURL(blob);

                link.download = "Emutabakat.xlsx";

                link.click();

            }, (response) => {

                if (response.status === 0) {

                    this.text1 = 'Service Unavailable'

                    this.snackbar = true

                    this.load1 = true

                    this.progress = false

                } else {

                    this.text1 = 'Service Unavailable'

                    this.snackbar = true

                    this.load1 = true

                    this.progress = false

                }

            })

    }

}

function beforeMount() {

}

function getDateNow() {

    var today = new Date();

    var dd = today.getDate();

    var mm = today.getMonth() + 1; //January is 0!

    var yyyy = today.getFullYear();

    if (dd < 10) {

        dd = '0' + dd

    }

    if (mm < 10) {

        mm = '0' + mm

    }

    today = yyyy + '-' + mm + '-' + dd

    return today

}

function getDateNow1() {

    var today = new Date();

    var dd = today.getDate();

    var mm = today.getMonth() + 1; //January is 0!

    var yyyy = today.getFullYear();

    if (dd < 10) {

        dd = '0' + dd

    }

    if (mm < 10) {

        mm = '0' + mm

    }

    today = dd + '.' + mm + '.' + yyyy

    return today

}

</script>

<style scoped>

/* @import '../../../assets/css/custom.css'; */

/* Bu stiller yalnızca mutabakatmektubu.vue sayfasına özeldir. */
.mutabakat-report-table {
    width: 100%;
    margin-top: 4px;
}

.mutabakat-report-table > * {
    width: 100%;
}

.mutabakat-action-cell {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

</style>
